type Fn = (...args: any[]) => any

class BatchInterval {
  private taskCallbackList: Array<Fn> = []
  private isRunning: boolean = false
  private interval: null | ReturnType<typeof setInterval> = null

  public addTask(fn: Fn) {
    this.taskCallbackList.push(fn)

    if (!this.isRunning) {
      this.isRunning = true
      this.startInterval()
    }
  }

  public removeTask(fn: Fn) {
    this.taskCallbackList = this.taskCallbackList.filter(f => f !== fn)

    if (this.taskCallbackList.length === 0 && this.isRunning && this.interval) {
      this.isRunning = false
      this.clearInterval()
    }
  }

  private startInterval() {
    console.warn('debug BatchInterval 启动定时器')
    this.clearInterval()

    this.interval = setInterval(() => {
      this.taskCallbackList.forEach(fn => fn())
    }, 200)
  }

  private clearInterval() {
    if (this.interval) {
      console.warn('debug BatchInterval 列表任务为空 清除定时器')
      clearTimeout(this.interval)
      this.interval = null
    }
  }
}

const batchInterval = new BatchInterval()

export default batchInterval
